import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import AppHeader from "./components/AppHeader";
import Home from "./components/Home";
import MobileAppHeader from "./components/MobileAppHeader";
import MobileSearchForm from "./components/MobileSearchForm";
import RouteAnalyticsTracker from "./components/RouteAnalyticsTracker";
import SearchForm from "./components/SearchForm";
import { AuthProvider } from "./context/AuthContext";
import { DeckProvider } from "./context/DeckContext";
import MobileDeckBuilder from "./pages/MobileDeckBuilder";
import MobileSearchResults from "./pages/MobileSearchResults";
import DeckBuilder from "./pages/DeckBuilder";
import SearchResults from "./pages/SearchResults";
import { useLayoutTier } from "./utils/deviceLayout";
import "./mobile.css";

const AppContent = () => {
  const location = useLocation();
  const isDeckRoute = location.pathname.startsWith("/deck");
  const { isCompactDesktop, isCompactLayout, isMobileOs, isIos, isAndroid } =
    useLayoutTier(location.search);

  const shellClassName = [
    "app-shell",
    isDeckRoute ? "app-shell-deck" : "",
    isCompactLayout ? "app-shell-mobile" : "",
    isCompactDesktop ? "app-shell-compact-desktop" : "",
    isMobileOs ? "app-shell-mobile-os" : "",
    isIos ? "app-shell-ios" : "",
    isAndroid ? "app-shell-android" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const HeaderComponent = isCompactLayout ? MobileAppHeader : AppHeader;
  const SearchFormComponent = isCompactLayout ? MobileSearchForm : SearchForm;
  const SearchResultsComponent = isCompactLayout ? MobileSearchResults : SearchResults;
  const DeckBuilderComponent = isCompactLayout ? MobileDeckBuilder : DeckBuilder;

  return (
    <div className={shellClassName}>
      <RouteAnalyticsTracker />
      <HeaderComponent />
      {location.pathname === "/" ? <SearchFormComponent /> : null}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/search" element={<SearchResultsComponent />} />
        <Route path="/deck" element={<DeckBuilderComponent />} />
      </Routes>
    </div>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <DeckProvider>
        <AppContent />
      </DeckProvider>
    </AuthProvider>
  );
};

export default App;
